import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromUserGroup from '../_reducers/userGroup';

export const selectUserGroupState =
  createFeatureSelector<fromUserGroup.UserGroupState>('userGroups');

export const selectAllUserGroups = createSelector(selectUserGroupState, fromUserGroup.selectAll);

export const selectUserGroupEntities = createSelector(
  selectUserGroupState,
  fromUserGroup.selectEntities
);

export const selectUserGroupById = (id: number) =>
  createSelector(selectUserGroupEntities, (entities) => entities[id]);

export const selectUserGroupTotal = createSelector(selectUserGroupState, fromUserGroup.selectTotal);
